import { Component } from '@angular/core';
import { AuthService } from '../../../services';

@Component({
  selector: 'app-dashboard-layout',
  standalone: false,
  templateUrl: './dashboard-layout.html',
  styleUrl: './dashboard-layout.css',
})
export class DashboardLayout {

 
  constructor(private auth: AuthService) {}
 
  logout(): void {
    this.auth.logout();
  }

  getUser(){
    return this.auth.getUser();
  }
}
